import React, { useEffect, useState } from "react";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";

const EventoLogisticoDetalheViagemPopup = (props: any) => {
    const [detalhes, setDetalhes] = useState<any>([]);

    const colunas: any[] = [
        { dataIndex: 'doca_origem', title: 'Doca', width: 100, minWidth: 100 },
        { dataIndex: 'numero_cliente', title: 'Numero Cliente', width: 100, minWidth: 100 },
        { dataIndex: 'tipo_registro', title: 'Tipo', width: 150, minWidth: 150 },
        { dataIndex: 'status_viagem', title: 'Status', width: 150, minWidth: 150 },
        { dataIndex: 'tempo', title: 'Tempo', width: 100, minWidth: 100 },
        { dataIndex: 'proximo_registro', title: 'Próximo', minWidth: 100, flex: 0.1, },
    ];

    useEffect(() => {
        const inicializa = async () => inicializaAsync();
        inicializa();
    }, []);
    
    async function inicializaAsync() {
        let response = await axios.get(`painelEventoLogisticoRegistroPorViagemId?viagem_id=${props.viagem_id}`);
        setDetalhes(response);
    }

    return (
        <div>
            <BasePopup title={"Detalhes Viagem ("+props.viagem_id + ")"} isOpen={props.isOpen} onClose={props.onClose} hideButtonNew={true}>
                <DataGridComponent
                    heightFix={250}
                    responseRows={detalhes}
                    paginationSide="client"
                    hideButtons={true}
                    columns={colunas} />
            </BasePopup>
        </div>
    );
}

export default EventoLogisticoDetalheViagemPopup;
